export default __webpack_public_path__ + "static/media/shopifyBlack.8800fe62.png";